<script lang="ts" setup>
const props = defineProps<{
  title: string,
  icon: string,
  href: string,
  disabled: boolean
}>();

const route = useRoute()
const isActive = computed(() => route.path === props.href);

const itemClicked = () => {
  if (props.disabled || !props.href) return;
  navigateTo(props.href);
};
</script>
<template>
  <li :class="['step-item', {'active': isActive}]">
    <span class="step-icon" @click="itemClicked">
      <VIcon :icon="icon"/>
    </span>
    <span class="step-title">{{ title }}</span>
  </li>
</template>